import _ from 'lodash';
import { getList } from '../../repository/dashboard-admin/index';

const state = {
  itemsList: null,
};

const getters = {
  itemsList: store => store.itemsList,
};
const mutations = {
  SET_ITEMS_LIST(state, itemsList) {
    state.itemsList = itemsList;
  },
};
const actions = {
  async getItemsList({ commit }) {
    commit('SET_ITEMS_LIST', null);
    const response = await getList();
    commit('SET_ITEMS_LIST', _.get(response, 'data.data.items', []));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
